var heading_default = {
  "fontElementMap": "_7-Nb8",
  "elementSpacing": "EGKQY",
  "headerOne": "hcuCF EGKQY",
  "headerTwo": "g7n2G EGKQY",
  "headerThree": "QUJmd EGKQY",
  "headerFour": "VQNbs EGKQY",
  "headerFive": "_5FCMA EGKQY",
  "headerSix": "_2I5t5 EGKQY",
  "child": "NKkSo"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
